@let pinCodeValue = this.pinCodeValue();

<nz-modal
  [nzVisible]="isVisible()"
  [nzTitle]="undefined"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzWrapClassName]="
    'blocking-modal__pincode-wrap' +
    (hasVirtualKeyboard() ? ' has-virtual-keyboard' : '') +
    (hasFocus() ? ' has-focus' : '')
  "
  nzWidth="100vw"
  (nzOnCancel)="isPinCodeShown.set(false)">
  <ng-container *nzModalContent>
    <div
      class="blocking-modal__surface"
      (touchstart)="handleTouchToShowPinCode($event)"
      (touchend)="handleTouchToShowPinCode($event)">
      <ng-content />
      @if (isPinCodeShown()) {
        <div class="blocking-modal__pincode">
          <h6 class="blocking-modal__pincode--title">Enter tech code</h6>
          <div class="blocking-modal__pincode--fields--wrapper">
            <div class="blocking-modal__pincode--fields">
              @for (pinCodeItem of pinCodeItemsFromLength(); track $index) {
                <div class="blocking-modal__pincode--field">
                  <input
                    #pinCodeInput
                    type="text"
                    inputmode="numeric"
                    [value]="pinCodeValue[$index]"
                    (focus)="removePinCodeValue($index)"
                    (blur)="returnPinCodeValue($event, $index)"
                    (input)="
                      setPinCodeValue($event.target.value, $index);
                      pinCodeInput.value = pinCodeInput.value[0]
                    "
                    (keydown)="handleBackspaceKeyDown($event, $index)" />
                  @if (pinCodeValue[$index] !== '') {
                    <div class="star" (click)="pinCodeInput.focus()">*</div>
                  }
                </div>
              }
            </div>
            @if (pinCodeError()) {
              <small class="blocking-modal__pincode--error">
                Incorrect PIN. Please try again
              </small>
            }
          </div>
          <div class="blocking-modal__pincode--actions">
            <button
              class="blocking-modal__pincode--actions--close"
              (click)="isPinCodeShown.set(false)">
              Cancel
            </button>
            <button (click)="confirmPinCode()">Submit</button>
          </div>
        </div>
      }
    </div>
  </ng-container>
</nz-modal>
